import { render, staticRenderFns } from "./LinkCompany.vue?vue&type=template&id=4b001c35&"
import script from "./LinkCompanyVue.ts?vue&type=script&lang=ts&"
export * from "./LinkCompanyVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports